import { LS } from 'consts/localStorage';
import { readFromLs } from 'helpers/helpers';
import { downArrow } from 'icons/downArrow.js';
import { ENGT_CHAT } from 'js/bot.model';
import { tick } from '../../assets/tick';
import './localeDropdown.scss';

export const LocaleDropdownTemplate = (data) => {
	const { enabledLanguages } = data;
	const botLanguage = readFromLs(LS().USER_LOCALE).toUpperCase() || ENGT_CHAT.get('config.botLanguage').toUpperCase();
	const downArrowColor = '#FFFFFF';

	const optionTemp = (lang) => {
		if (lang.langCode === botLanguage.toLowerCase()) {
			return `<div id="${
				lang.langCode
			}" class="lang-dropdown-options selected-option" onclick="ENGT_CHAT.onChangeLanguage(this)" ><span id="tickForLang">${tick()}</span><span id='option-${
				lang.langCode
			}'>${lang.langName} (${lang.langCode.toUpperCase()})</span></div>`;
		}
		return `<div id="${
			lang.langCode
		}" class="lang-dropdown-options" onclick="ENGT_CHAT.onChangeLanguage(this)" ><span id='option-${
			lang.langCode
		}'>${lang.langName} (${lang.langCode.toUpperCase()})</span></div>`;
	};
	const getLangOptions = () => {
		let allOptionsHtml = '';
		enabledLanguages?.map((lang, index) => {
			allOptionsHtml += optionTemp(lang);
		});
		return allOptionsHtml;
	};

	const lang_dropDown = `<div class="engt-lang-dropdown">${getLangOptions()}</div>`;

	/* html */
	const html = `<div><div id="languageDropdown" class="engt-tab-selectable" onclick="ENGT_CHAT.showdropDown()"><span id='botLang'>${botLanguage}</span>${downArrow(
		downArrowColor
	)}</div> ${lang_dropDown}</div>`;
	return html;
};
